import React from 'react';
import { Link } from 'react-router-dom';
import FadeIn from '../common/FadeIn';
import introImg from "../../assets/images/intro.png";

const BrandStorySection = () => {
  return (
    <section className="container bg-[#f9f9f5] mx-auto text-[#1C1917] flex-center">
      <div className="flex flex-col md:flex-row items-center justify-center gap-[40px] md:gap-[50px] lg:gap-[70px] py-[50px] md:py-[65px] px-[16px] md:px-[25px] lg:px-10">

        <div className="order-1 md:order-2 w-full md:w-auto flex justify-center md:justify-end shrink-0">
          <FadeIn className="w-full md:w-auto flex justify-center md:justify-end">
            <div className="w-full h-[344px] sm:w-[280px] sm:h-[390px] md:w-[350px] md:h-[490px] lg:w-[400px] lg:h-[560px] overflow-hidden flex items-center justify-center rounded-sm shadow-xs">
              <img
                src={introImg}
                alt="Princy Patel - Founder & Lead Web Designer at SeaSalt Creative"
                className="w-full h-full object-cover object-top"
                loading="lazy"
                decoding="async"
                width="400"
                height="560"
              />
            </div>
          </FadeIn>
        </div>

        <div className="order-2 md:order-1 flex flex-col items-center md:items-start text-center md:text-left w-full sm:max-w-[420px] md:max-w-[540px] lg:max-w-[580px]">
          <FadeIn>
            <h3 className="font-saolDisplayItalic text-[30px] leading-[1.1] md:text-[46px] lg:text-[50px] md:leading-[1.08] tracking-[0em] font-normal mb-[20px] md:mb-[24px]">
              For creatives ready to grow,<br />
              with intention
            </h3>
          </FadeIn>

          <FadeIn>
            <div className="mb-[18px] md:mb-[22px]">
              <span className="font-montserratMedium uppercase text-[10px] md:text-[11px] tracking-[0.16em] font-bold block mb-1">
                Tailored Web Design by Princy Patel
              </span>
              <p className="font-interDisplayMedium leading-[1.75] tracking-[0em] text-[12px] md:text-[13.5px] font-light text-[#1C1917]">
                Hi, I'm Princy Patel. I create clean, professional websites that are made around your business and the way you want your brand to look. You choose a design you like, and I customize it with your own content, images, colors, logo, and branding.
              </p>
            </div>
          </FadeIn>

          <FadeIn>
            <div className="mb-[18px] md:mb-[22px]">
              <span className="font-montserratMedium uppercase text-[10px] md:text-[11px] tracking-[0.16em] font-bold block mb-1">
                Simple & Seamless Process
              </span>
              <p className="font-interDisplayMedium leading-[1.75] tracking-[0em] text-[12px] md:text-[13.5px] font-light text-[#1C1917]">
                I keep the process simple from start to finish. You don't have to worry about complicated steps or starting everything from scratch. I take the design you like and make it work for your business, while keeping the website easy to use, responsive, and professional on every screen.
              </p>
            </div>
          </FadeIn>

          <FadeIn>
            <div className="mb-[20px] md:mb-[24px]">
              <span className="font-montserratMedium uppercase text-[10px] md:text-[11px] tracking-[0.16em] font-bold block mb-1">
                Built For Impact
              </span>
              <p className="font-interDisplayMedium leading-[1.75] tracking-[0em] text-[12px] md:text-[13.5px] font-light text-[#1C1917]">
                Whether you are a photographer, creative, small business owner, or growing brand, the goal is simple — to give you a website that looks good, represents your work properly, and makes it easy for people to get in touch.
              </p>
            </div>
          </FadeIn>

          <FadeIn className="w-full">
            <div className="border-l-2 border-black pl-3.5 py-0.5 mb-[24px] md:mb-[28px] text-left">
              <p className="font-saolDisplayItalic text-[16px] md:text-[19px] text-[#1C1917] leading-snug">
                Good design. Clear purpose. Your website, your way.
              </p>
            </div>
          </FadeIn>

          <FadeIn>
            <Link
              to="/inquiry"
              className="font-montserratMedium font-medium inline-flex items-center justify-center p-[16px_18px_15px_18px] bg-[#ce884d] text-[#ffffff] font-semibold leading-[1.8] tracking-[0.1em] text-[9px] lg:text-[11px] cursor-pointer duration-[0.5s] hover:bg-[#ccc3ad] hover:text-black uppercase w-[220px] h-[50px] lg:w-[240px] lg:h-[60px]"
            >
              START YOUR WEBSITE
            </Link>
          </FadeIn>
        </div>

      </div>
    </section>
  );
};

export default BrandStorySection;
